(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2723],{

/***/ 34724:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ products_ProductPage; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(94776);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(70423);
// EXTERNAL MODULE: ../../node_modules/use-media/lib/index.js
var lib = __webpack_require__(81145);
// EXTERNAL MODULE: ../../packages/sf-modules/src/index.js + 26 modules
var src = __webpack_require__(37555);
// EXTERNAL MODULE: ../../packages/commerce/src/useStateEngine.tsx
var useStateEngine = __webpack_require__(99436);
// EXTERNAL MODULE: ../../packages/commerce/src/hooks/tracking/useTracker.ts
var useTracker = __webpack_require__(69590);
// EXTERNAL MODULE: ./constants/paths.js
var paths = __webpack_require__(69514);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/atoms/Blobs/Blobs.jsx




var Blobs = function(param) {
    var rawBlobs = param.blobs, name = param.name;
    var getBlob = function(word) {
        return {
            word: word,
            color: "",
            fontColor: "",
            borderColor: "",
            borderRadius: "",
            borderStyle: "",
            borderWidth: ""
        };
    };
    var blobs = (rawBlobs === null || rawBlobs === void 0 ? void 0 : rawBlobs.length) ? rawBlobs : name.split(" ").map(function(x) {
        return getBlob(x);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
        className: "mt-2 mb-4 text-caption",
        children: blobs.map(function(blob, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: classnames_default()("my-0.5 inline-block py-1.5 px-3.5 font-heading text-h2 font-heading-regular", [
                            "".concat(!blob.borderWidth && (!blob.color || blob.color === "") ? "no-blob" : ""), 
                        ]),
                        style: {
                            backgroundColor: blob.color ? blob.color : "#FFFFFF",
                            color: blob.fontColor ? blob.fontColor : "#000000",
                            borderColor: blob.borderColor ? blob.borderColor : blob.borderWidth ? "black" : "transparent",
                            borderRadius: blob.borderRadius ? blob.borderRadius : "0",
                            borderStyle: blob.borderStyle ? blob.borderStyle : "none",
                            borderWidth: blob.borderWidth ? blob.borderWidth : blob.borderStyle === "dashed" || blob.borderStyle === "solid" ? "1px" : "0"
                        },
                        children: blob.word
                    }),
                    " "
                ]
            }, "product-blob-" + index);
        })
    });
};
Blobs.defaultProps = {
    blobs: [],
    name: ""
};
Blobs.Proptypes = {
    blobs: (prop_types_default()).array,
    name: (prop_types_default()).string
};
/* harmony default export */ var Blobs_Blobs = (Blobs);

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/atoms/Blobs/index.js


// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/Hr/index.js + 1 modules
var Hr = __webpack_require__(40636);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/UspImageText/index.js + 1 modules
var UspImageText = __webpack_require__(98504);
// EXTERNAL MODULE: ../../packages/icons/solid/esm/CameraIcon.js
var CameraIcon = __webpack_require__(32841);
// EXTERNAL MODULE: ../../node_modules/keen-slider/react.js
var keen_slider_react = __webpack_require__(6158);
// EXTERNAL MODULE: ../../node_modules/react-inner-image-zoom/es/index.js + 5 modules
var es = __webpack_require__(71196);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/Image/index.js
var Image = __webpack_require__(4740);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/BulletIndicator/index.js + 1 modules
var BulletIndicator = __webpack_require__(75017);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/molecules/ProductImageSlider/ProductImageSlider.module.scss
var ProductImageSlider_module = __webpack_require__(77912);
var ProductImageSlider_module_default = /*#__PURE__*/__webpack_require__.n(ProductImageSlider_module);
;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/molecules/ProductImageSlider/ProductImageSlider.jsx














var SliderControlBullets = function(param) {
    var bulletsWrapperClassName = param.bulletsWrapperClassName, currentSlide = param.currentSlide, slider = param.slider, images = param.images;
    // @TODO ANA: Improve bullets animation
    var isDesktop = (0,lib/* useMedia */.GS)({
        minWidth: 1024
    });
    var wrapperClasName = classnames_default()(bulletsWrapperClassName, "dots inline-flex", {
        "w-full": !isDesktop
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: wrapperClasName,
        children: images.map(function(image, idx) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                children: !isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BulletIndicator/* default */.Z, {
                    type: "rect",
                    onClick: function() {
                        slider.moveToSlideRelative(idx);
                    },
                    className: classnames_default()("mr-1 cursor-pointer bg-ui-gray-300 last:mr-0", {
                        "!bg-ui-gray-900": currentSlide === idx
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    onClick: function() {
                        slider.moveToSlideRelative(idx);
                    },
                    className: "mr-2.5 last:mr-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("relative h-18 w-18 cursor-pointer overflow-hidden border-2 transition duration-300 ease-out hover:opacity-75", {
                            "rounded-sm border-ui-gray-300 hover:border-brand-primary-700": currentSlide !== idx,
                            "rounded-full border-brand-primary-700 !bg-ui-gray-900": currentSlide === idx
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            layout: "fixed",
                            objectFit: "cover",
                            objectPosition: "center",
                            width: 72,
                            height: 72,
                            src: image.url
                        })
                    })
                })
            }, idx);
        })
    });
};
var ProductImageSlider = function(param) {
    var productName = param.productName, images = param.images;
    var ref = (0,react.useState)(0), currentSlide = ref[0], setCurrentSlide = ref[1];
    var initialOptions = {
        initial: 0,
        spacing: 2,
        controls: true,
        slideChanged: function slideChanged(s) {
            setCurrentSlide(s.details().relativeSlide);
        },
        breakpoints: {
            "(min-width: 1024px)": {
                controls: false
            }
        },
        resetSlide: true
    };
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,keen_slider_react.useKeenSlider)((0,_object_spread/* default */.Z)({}, initialOptions)), 2), sliderRef = ref1[0], slider = ref1[1];
    (0,react.useEffect)(function() {
        if (slider && images) {
            slider.refresh((0,_object_spread/* default */.Z)({}, initialOptions));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        slider,
        images
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: images && images.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()((ProductImageSlider_module_default()).KeenSliderWrapper, "relative w-full"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: sliderRef,
                    id: "productImageSlider",
                    className: "keen-slider",
                    children: images.map(function(image, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "keen-slider__slide",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageElement, {
                                url: image.url,
                                alt: image.altText ? image.altText : productName
                            })
                        }, "product-image-slider-" + index);
                    })
                }),
                slider && /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderControlBullets, {
                    slider: slider,
                    images: images,
                    currentSlide: currentSlide,
                    bulletsWrapperClassName: "absolute lg:relative z-100 lg:mt-6"
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "w-full",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CameraIcon/* default */.Z, {
                className: "mx-auto flex w-3/5 pt-12 pb-32"
            })
        })
    });
};
var ImageElement = function(param) {
    var url = param.url, alt = param.alt;
    if (false) {}
    var withWebp = src/* sessionstorage.get */.zN.get("webpSupport", false) === "true";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (ProductImageSlider_module_default()).IizWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* default */.Z, {
            className: "w-full",
            src: src/* imageTools.getOptimizedImageURL */.d$.getOptimizedImageURL(url, {
                f: withWebp ? "webp" : "jpg",
                w: 688,
                t: "crop"
            }),
            zoomSrc: src/* imageTools.getOptimizedImageURL */.d$.getOptimizedImageURL(url, {
                f: withWebp ? "webp" : "jpg",
                w: 2000,
                t: "crop"
            }),
            alt: alt
        })
    });
};
ProductImageSlider.defaultProps = {};
ProductImageSlider.propTypes = {
    productName: prop_types.string,
    images: prop_types.array.isRequired
};
/* harmony default export */ var ProductImageSlider_ProductImageSlider = (/*#__PURE__*/react.memo(ProductImageSlider));

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/molecules/ProductImageSlider/index.js


// EXTERNAL MODULE: ../../packages/icons/solid/esm/CheckIcon.js
var CheckIcon = __webpack_require__(14718);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/Image/Image.jsx
var Image_Image = __webpack_require__(66483);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/molecules/Accordion/Accordion.jsx
var Accordion = __webpack_require__(79674);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/Link/Link.jsx
var Link = __webpack_require__(73769);
;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/organisms/ProductDetails/ProductDetails.jsx








var ProductFeature = function(param) {
    var wrapperClassName = param.wrapperClassName, accordionTittle = param.accordionTittle, activeTab = param.activeTab, children = param.children, linkText = param.linkText, handleToggle = param.handleToggle, onClickLink = param.onClickLink;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: wrapperClassName,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default */.Z, {
            active: activeTab,
            title: accordionTittle,
            childrenClassName: classnames_default()(linkText && "flex flex-col gap-y-2"),
            toggleAccordion: handleToggle,
            withBorder: true,
            children: [
                children,
                linkText && typeof onClickLink === "function" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                    onClick: onClickLink,
                    children: linkText
                })
            ]
        }, "accordion")
    });
};
var ProductContent = function(param) {
    var facets = param.facets;
    return facets.filter(function(f) {
        return f.isMain;
    }).map(function(facet, index) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckIcon/* default */.Z, {
                    className: "mr-3 mt-1 h-4 w-4 rounded-full bg-black fill-white stroke-white stroke-2 p-1"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: facet.name && facet.name !== "" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                className: "mb-2.5 mt-0 font-heading text-normal text-ui-black",
                                children: facet.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "font-body text-small",
                                children: facet === null || facet === void 0 ? void 0 : facet.description
                            })
                        ]
                    })
                })
            ]
        }, (facet === null || facet === void 0 ? void 0 : facet.id) || index);
    });
};
var ProductIngredients = function(param) {
    var ingredients = param.ingredients, products = param.products, isBundle = param.isBundle, PATH_PRODUCT_PAGE = param.PATH_PRODUCT_PAGE;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
        className: "list-inside list-disc",
        children: [
            ingredients && ingredients.length > 0 && ingredients.map(function(param) {
                var id = param.id, name = param.name, breakdown = param.breakdown;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                    children: [
                        name,
                        " ",
                        breakdown && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "text-ui-gray-500",
                            children: [
                                "(",
                                breakdown,
                                ")"
                            ]
                        })
                    ]
                }, id);
            }),
            isBundle && products.slice(0, 8).map(function(subproduct, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                    className: "mt-2 flex items-start",
                    children: [
                        subproduct.quantity && subproduct.quantity + "x ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            className: "font-light ml-2",
                            href: PATH_PRODUCT_PAGE + "/" + subproduct.slug,
                            children: subproduct.name
                        })
                    ]
                }, "subproduct-" + index);
            })
        ]
    });
};
var ProductDetail = function(param) {
    var product = param.product, isMobile = param.isMobile, modalContent = param.modalContent, setModalContent = param.setModalContent, PATH_PRODUCT_PAGE = param.PATH_PRODUCT_PAGE;
    var ref;
    var ref1 = (0,react.useState)(0), activeTab = ref1[0], setActiveTab = ref1[1];
    var productImage = product.images && product.images.length ? (product.images || []).find(function(x) {
        return x.isInCollapsedSection;
    }) || product.images[product.images.length - 1] : null;
    var _longDescription;
    var productDescriptionHTML = /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: "font-body text-ui-black",
        dangerouslySetInnerHTML: {
            __html: (_longDescription = product.longDescription) !== null && _longDescription !== void 0 ? _longDescription : product.description
        }
    });
    var toggleTab = function(number) {
        if (isMobile) switch(number){
            case 0:
                setModalContent({
                    title: "Acerca de: ",
                    content: productDescriptionHTML,
                    isOpen: true
                });
                break;
            case 1:
                setModalContent({
                    title: "\xbfPor qu\xe9 lo amamos?",
                    content: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductContent, {
                        facets: product.facets
                    }),
                    isOpen: true
                });
                break;
            case 2:
                setModalContent({
                    title: product.isBundle ? "\xbfQu\xe9 incluye?" : "De qu\xe9 est\xe1 hecho",
                    content: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductIngredients, {
                        isBundle: product === null || product === void 0 ? void 0 : product.isBundle,
                        products: product === null || product === void 0 ? void 0 : product.products,
                        ingredients: product.ingredients,
                        PATH_PRODUCT_PAGE: PATH_PRODUCT_PAGE
                    }),
                    isOpen: true
                });
                break;
        }
        else {
            activeTab === number ? setActiveTab(null) : setActiveTab(number);
        }
    };
    var _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                backgroundColor: (product === null || product === void 0 ? void 0 : product.backgroundColor) || "#fdf2f1"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container flex w-full pb-2 lg:max-h-[607px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mr-2 flex w-full flex-col overflow-auto lg:max-h-max lg:w-1/2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductFeature, {
                                accordionTittle: "Acerca de",
                                handleToggle: function() {
                                    return toggleTab(0);
                                },
                                activeTab: activeTab === 0 && !isMobile,
                                children: productDescriptionHTML
                            }),
                            (product === null || product === void 0 ? void 0 : product.facets) && (product === null || product === void 0 ? void 0 : (ref = product.facets) === null || ref === void 0 ? void 0 : ref.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductFeature, {
                                accordionTittle: "\xbfPor qu\xe9 lo amamos?",
                                handleToggle: function() {
                                    return toggleTab(1);
                                },
                                activeTab: activeTab === 1 && !isMobile,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductContent, {
                                    facets: product.facets
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductFeature, {
                                accordionTittle: product.isBundle ? "\xbfQu\xe9 incluye?" : "De qu\xe9 est\xe1 hecho",
                                handleToggle: function() {
                                    return toggleTab(2);
                                },
                                activeTab: activeTab === 2 && !isMobile,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductIngredients, {
                                    ingredients: product === null || product === void 0 ? void 0 : product.ingredients,
                                    isBundle: product === null || product === void 0 ? void 0 : product.isBundle,
                                    products: product === null || product === void 0 ? void 0 : product.products,
                                    PATH_PRODUCT_PAGE: PATH_PRODUCT_PAGE
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative hidden h-0 lg:block lg:h-[607px] lg:w-1/2",
                        children: productImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_Image/* default */.Z, {
                            src: productImage.url,
                            alt: (_alt = productImage.alt) !== null && _alt !== void 0 ? _alt : productImage.name,
                            layout: "fill",
                            objectFit: "cover",
                            objectPosition: "center"
                        })
                    })
                ]
            })
        })
    });
};
ProductDetail.propTypes = {
    product: prop_types.object,
    isMobile: prop_types.bool,
    modalContent: prop_types.object,
    setModalContent: prop_types.func,
    PATH_PRODUCT_PAGE: prop_types.string
};
/* harmony default export */ var ProductDetails = (ProductDetail);

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/organisms/ProductDetails/index.js


// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ../../packages/designkit/src/components/schemas/RichContent.js





var RichContent = function(param) {
    var product = param.product, catalogPrice = param.catalogPrice;
    var ref, ref1, ref2, ref3, ref4;
    var priceToPayPerUnit = (catalogPrice === null || catalogPrice === void 0 ? void 0 : catalogPrice.discountedPrice) < (catalogPrice === null || catalogPrice === void 0 ? void 0 : catalogPrice.price) ? catalogPrice === null || catalogPrice === void 0 ? void 0 : catalogPrice.discountedPrice : catalogPrice === null || catalogPrice === void 0 ? void 0 : catalogPrice.price;
    var priceValidUntilNextYear = new Date();
    priceValidUntilNextYear.setFullYear(priceValidUntilNextYear.getFullYear() + 1);
    var productSchemaMarkup = {
        __html: JSON.stringify((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            "@context": "https://schema.org/",
            "@type": "Product",
            name: product.name,
            image: ((ref = product.images) === null || ref === void 0 ? void 0 : ref.map(function(x) {
                return x.url;
            })) || [],
            description: product.seoDescription,
            sku: product.sku,
            gtin: product.gtin,
            url: product.href ? "".concat("https://yema.mx").concat(product.href) : null,
            brand: {
                "@type": "Brand",
                name: product.brand
            }
        }, !!(product === null || product === void 0 ? void 0 : (ref1 = product.reviews) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.items) === null || ref2 === void 0 ? void 0 : ref2.length) ? {
            review: product === null || product === void 0 ? void 0 : (ref3 = product.reviews) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.items) === null || ref4 === void 0 ? void 0 : ref4.map(function(x) {
                return {
                    "@type": "Review",
                    reviewRating: {
                        "@type": "Rating",
                        ratingValue: x.rating,
                        worstRating: "1",
                        bestRating: "5"
                    },
                    name: x.title,
                    author: {
                        "@type": "Person",
                        name: x.reviewerName,
                        datePublished: new Date(x.created).toISOString()
                    },
                    reviewBody: x.content
                };
            })
        } : {}, (0,src/* get_ */.jR)(product, [
            "reviews",
            "count"
        ], 0) > 0 ? {
            aggregateRating: {
                "@type": "AggregateRating",
                ratingValue: product.reviews.average,
                reviewCount: product.reviews.count,
                ratingCount: product.reviews.count,
                worstRating: "1",
                bestRating: "5"
            }
        } : {}), {
            offers: {
                "@type": "Offer",
                url: product.href ? "".concat("https://yema.mx").concat(product.href) : null,
                priceCurrency: "MXN",
                price: priceToPayPerUnit,
                priceValidUntil: (catalogPrice === null || catalogPrice === void 0 ? void 0 : catalogPrice.discountValidUntil) ? catalogPrice === null || catalogPrice === void 0 ? void 0 : catalogPrice.discountValidUntil : priceValidUntilNextYear,
                availability: product.itemStatus === "INACTIVE" ? "https://schema.org/OutOfStock" : "https://schema.org/InStock"
            }
        }))
    };
    // Cannot use here next/script since embedded script should change on client navigation (does not work with next/script)
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
            id: "product-schema-".concat(product.sku),
            type: "application/ld+json",
            dangerouslySetInnerHTML: productSchemaMarkup
        })
    });
};
/* harmony default export */ var schemas_RichContent = (RichContent);

// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/Link/index.js
var atoms_Link = __webpack_require__(35384);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/Rating/index.js + 2 modules
var Rating = __webpack_require__(50952);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/molecules/Usp/index.js + 1 modules
var Usp = __webpack_require__(55049);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/Breadcrumb/index.js + 1 modules
var Breadcrumb = __webpack_require__(62581);
;// CONCATENATED MODULE: ./components/products/YDSProductPageBreadcrumb.js





var YDSProductPageBreadcrumb = function(param) {
    var productBreadcrumb = param.productBreadcrumb;
    var isMobile = (0,lib/* default */.ZP)({
        maxWidth: 1024
    });
    var beforeLastLink = productBreadcrumb.length >= 2 ? productBreadcrumb[productBreadcrumb.length - 2] : null;
    var lastProductBreadcrumbItem = [
        {
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: beforeLastLink.link,
                children: "< Regresar a ".concat(beforeLastLink.title)
            })
        }, 
    ];
    if (!productBreadcrumb || !productBreadcrumb.length) return "";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "block",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default */.Z, {
                        className: "my-4 lg:my-6",
                        breadcrumbs: beforeLastLink && isMobile ? lastProductBreadcrumbItem : productBreadcrumb
                    })
                })
            })
        })
    });
};
YDSProductPageBreadcrumb.defaultProps = {};
YDSProductPageBreadcrumb.propTypes = {
    productBreadcrumb: prop_types.array.isRequired
};
/* harmony default export */ var products_YDSProductPageBreadcrumb = (YDSProductPageBreadcrumb);

// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/Product/ProductPriceForQuantity.jsx
var ProductPriceForQuantity = __webpack_require__(29832);
// EXTERNAL MODULE: ./functions/fnRequestAPIs/fnProductsAPI.js + 7 modules
var fnProductsAPI = __webpack_require__(66221);
// EXTERNAL MODULE: ./functions/fnRequestAPIs/fnProductsPromotion.js + 1 modules
var fnProductsPromotion = __webpack_require__(18009);
;// CONCATENATED MODULE: ./components/products/ProductPage.js





























var AddToCart = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1319).then(__webpack_require__.bind(__webpack_require__, 11319));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(11319)
            ];
        }
    },
    ssr: false
});
var AddToCartSticky = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6736).then(__webpack_require__.bind(__webpack_require__, 86736));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(86736)
            ];
        }
    },
    ssr: false
});
var ProductReviews = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1992), __webpack_require__.e(7529), __webpack_require__.e(7702)]).then(__webpack_require__.bind(__webpack_require__, 37365));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(37365)
            ];
        }
    },
    ssr: false
});
var YDSProductSlider = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1607), __webpack_require__.e(1992), __webpack_require__.e(7261), __webpack_require__.e(4787), __webpack_require__.e(3960)]).then(__webpack_require__.bind(__webpack_require__, 14787));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(14787)
            ];
        }
    },
    ssr: false
});
var YDSRelatedProductsSlider = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1607), __webpack_require__.e(1992), __webpack_require__.e(7003), __webpack_require__.e(7261), __webpack_require__.e(4787), __webpack_require__.e(9244)]).then(__webpack_require__.bind(__webpack_require__, 58688));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(58688)
            ];
        }
    },
    ssr: false
});
var FullModal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1651).then(__webpack_require__.bind(__webpack_require__, 11651));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(11651)
            ];
        }
    },
    ssr: false
});
var ProductPage = function(param) {
    var uspPromo = param.uspPromo, uspPromise = param.uspPromise, product = param.product, productBreadcrumb = param.productBreadcrumb;
    var ref;
    var INITIAL_MODAL_CONTENT = {
        title: "",
        content: "",
        isOpen: false
    };
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useStateEngine/* default */.Z)(), 1), catalog = ref1[0].catalog;
    var isMobile = (0,lib/* useMedia */.GS)({
        maxWidth: 640
    });
    var isMobileXS = (0,lib/* useMedia */.GS)({
        maxWidth: 320
    });
    var trackEvent = (0,useTracker/* default */.Z)().trackEvent;
    var ref2 = (0,react.useState)(false), pageIsReady = ref2[0], setPageIsReady = ref2[1];
    var ref3 = (0,react.useState)(null), fetchedCatalog = ref3[0], setFetchedCatalog = ref3[1];
    var ref4 = (0,react.useState)((product === null || product === void 0 ? void 0 : product.catalogPrice) || null), catalogPrice = ref4[0], setCatalogPrice = ref4[1];
    var ref5 = (0,react.useState)(null), availability = ref5[0], setAvailability = ref5[1];
    var ref6 = (0,react.useState)(null), firstApplicableRule = ref6[0], setFirstApplicableRule = ref6[1];
    var ref7 = (0,react.useState)([]), bundleProducts = ref7[0], setBundleProducts = ref7[1];
    var ref8 = (0,react.useState)(false), showSticky = ref8[0], setShowSticky = ref8[1];
    var ref9 = (0,react.useState)(INITIAL_MODAL_CONTENT), modalContent = ref9[0], setModalContent = ref9[1];
    var productDescriptionPlainText = (0,src/* htmlToPlainText */.dH)(product.description);
    var refetchAvailabilitiesAndPromotions = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var _shouldRefetchAvailabilities, shouldRefetchAvailabilities, _shouldRefetchPromotions, shouldRefetchPromotions, ref, ref1, gtinsToFetch, bundlesIdToFetch, productIds, plmIds, bundlesSkus, fetchedPromotionsPromise, fetchedAvailabilitiesPromise;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _shouldRefetchAvailabilities = param.shouldRefetchAvailabilities, shouldRefetchAvailabilities = _shouldRefetchAvailabilities === void 0 ? false : _shouldRefetchAvailabilities, _shouldRefetchPromotions = param.shouldRefetchPromotions, shouldRefetchPromotions = _shouldRefetchPromotions === void 0 ? false : _shouldRefetchPromotions;
                        ;
                        if (!(!catalog || !catalog.zipCode)) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 4:
                        gtinsToFetch = [];
                        bundlesIdToFetch = [];
                        if (product.isBundle) bundlesIdToFetch.push(product.sku);
                        else gtinsToFetch.push(product.gtin);
                        productIds = (0,src/* get_ */.jR)(product, [
                            "rawId"
                        ]);
                        plmIds = (0,src/* get_ */.jR)(product, [
                            "plmId"
                        ]);
                        bundlesSkus = (0,src/* get_ */.jR)(product, [
                            "skus"
                        ], []);
                        gtinsToFetch = (0,_to_consumable_array/* default */.Z)(gtinsToFetch).concat((0,_to_consumable_array/* default */.Z)(bundlesSkus));
                        fetchedPromotionsPromise = shouldRefetchPromotions ? (0,fnProductsPromotion/* fetchProductsPromotions */.a)({
                            gtinsToFetch: gtinsToFetch,
                            bundlesIdToFetch: bundlesIdToFetch,
                            plmIds: plmIds ? [
                                plmIds
                            ] : null,
                            productIds: productIds ? [
                                productIds
                            ] : null,
                            storeId: catalog === null || catalog === void 0 ? void 0 : (ref = catalog.store) === null || ref === void 0 ? void 0 : ref.id
                        }) : null;
                        fetchedAvailabilitiesPromise = shouldRefetchAvailabilities ? (0,fnProductsAPI/* getProductsAvailability */.hj)({
                            gtins: (0,_to_consumable_array/* default */.Z)(gtinsToFetch).concat((0,_to_consumable_array/* default */.Z)(bundlesIdToFetch)),
                            plmIds: plmIds ? [
                                plmIds
                            ] : null,
                            productIds: productIds ? [
                                productIds
                            ] : null,
                            zipCode: catalog ? catalog.zipCode : null,
                            storeId: catalog === null || catalog === void 0 ? void 0 : (ref1 = catalog.store) === null || ref1 === void 0 ? void 0 : ref1.id
                        }) : null;
                        Promise.all([
                            fetchedPromotionsPromise,
                            fetchedAvailabilitiesPromise
                        ]).then(function(res) {
                            var fetchedPromotions = (0,src/* get_ */.jR)(res, [
                                0
                            ]);
                            var fetchedAvailabilities = (0,src/* get_ */.jR)(res, [
                                1
                            ]);
                            // Set main product availability
                            if (shouldRefetchAvailabilities) {
                                var ref, ref1;
                                var mainProductAvailability = fetchedAvailabilities === null || fetchedAvailabilities === void 0 ? void 0 : (ref = fetchedAvailabilities.availabilities) === null || ref === void 0 ? void 0 : ref.find(function(x) {
                                    return x.gtin === product.gtin;
                                });
                                var parsedAvailability = src/* dataTransformers.parseAvailability */.IZ.parseAvailability(catalog === null || catalog === void 0 ? void 0 : catalog.zipCode, product, mainProductAvailability);
                                setCatalogPrice(fetchedAvailabilities === null || fetchedAvailabilities === void 0 ? void 0 : (ref1 = fetchedAvailabilities.prices) === null || ref1 === void 0 ? void 0 : ref1.find(function(x) {
                                    return x.sku === product.gtin;
                                }));
                                setAvailability(parsedAvailability);
                                setFetchedCatalog(catalog.zipCode);
                            }
                            // Set main product promotions
                            if (shouldRefetchPromotions) {
                                var mainProductPromotion = product.isBundle ? fetchedPromotions === null || fetchedPromotions === void 0 ? void 0 : fetchedPromotions.bundlesPromotions.find(function(x) {
                                    return x.sku === product.gtin;
                                }) : fetchedPromotions === null || fetchedPromotions === void 0 ? void 0 : fetchedPromotions.productsPromotions.find(function(x) {
                                    return x.gtin === product.gtin;
                                });
                                var firstApplicableRule = src/* rules.getFirstApplicableRule */.jQ.getFirstApplicableRule((0,src/* get_ */.jR)(mainProductPromotion, [
                                    "applicableRules"
                                ], []), product.gtin);
                                setFirstApplicableRule({
                                    title: (0,src/* get_ */.jR)(firstApplicableRule, [
                                        "title"
                                    ]),
                                    icon: (0,src/* get_ */.jR)(firstApplicableRule, [
                                        "campaignIcon"
                                    ])
                                });
                            }
                            // Set bundles products information
                            if (product.isBundle && bundlesSkus.length) {
                                var products = bundleProducts && bundleProducts.length ? bundleProducts : product.products;
                                setBundleProducts(products.map(function(p) {
                                    var ref, ref1;
                                    var availability = fetchedAvailabilitiesPromise ? (0,_object_spread/* default */.Z)({}, p.availability, src/* dataTransformers.parseAvailability */.IZ.parseAvailability(catalog === null || catalog === void 0 ? void 0 : catalog.zipCode, p, fetchedAvailabilities === null || fetchedAvailabilities === void 0 ? void 0 : (ref = fetchedAvailabilities.availabilities) === null || ref === void 0 ? void 0 : ref.find(function(x) {
                                        return x.gtin === p.gtin;
                                    }))) : p.availability;
                                    var firstApplicableRule = !shouldRefetchPromotions ? p.firstApplicableRule : (0,src/* get_ */.jR)(src/* rules.getFirstApplicableRule */.jQ.getFirstApplicableRule((0,src/* get_ */.jR)(fetchedPromotions.productsPromotions.find(function(x) {
                                        return x.gtin === p.gtin;
                                    }), [
                                        "applicableRules"
                                    ], []), p.gtin), [
                                        "title"
                                    ]);
                                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, p), {
                                        availability: availability,
                                        firstApplicableRule: firstApplicableRule,
                                        catalogPrice: fetchedAvailabilities === null || fetchedAvailabilities === void 0 ? void 0 : (ref1 = fetchedAvailabilities.prices) === null || ref1 === void 0 ? void 0 : ref1.find(function(x) {
                                            return x.sku === p.gtin;
                                        })
                                    });
                                }));
                            }
                            // All pricing, availability & promotions infos is loaded
                            setPageIsReady(true);
                        });
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function refetchAvailabilitiesAndPromotions(_) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (pageIsReady) {
            trackEvent({
                type: "Product Viewed",
                data: {
                    rawProduct: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, product), {
                        catalogPrice: catalogPrice
                    })
                }
            });
        }
    }, [
        pageIsReady
    ]);
    (0,react.useEffect)(function() {
        if (fetchedCatalog) {
            setPageIsReady(false);
            refetchAvailabilitiesAndPromotions({
                shouldRefetchAvailabilities: true,
                shouldRefetchPromotions: true
            });
        }
    // This useEffect should be triggered only on product change (i.e. client-side navigation)
    }, [
        product
    ]);
    (0,react.useEffect)(function() {
        if (catalog && catalog.createdAt && catalog.createdAt !== "") {
            refetchAvailabilitiesAndPromotions({
                shouldRefetchAvailabilities: true,
                shouldRefetchPromotions: true
            });
        }
    // This useEffect should be triggered only on zipCode or store change
    }, [
        catalog === null || catalog === void 0 ? void 0 : catalog.zipCode,
        catalog === null || catalog === void 0 ? void 0 : (ref = catalog.store) === null || ref === void 0 ? void 0 : ref.id
    ]);
    var stickyRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (isMobile) {
            var handleScroll = function handleScroll() {
                var ref;
                if ((stickyRef === null || stickyRef === void 0 ? void 0 : stickyRef.current) !== null && (stickyRef === null || stickyRef === void 0 ? void 0 : (ref = stickyRef.current) === null || ref === void 0 ? void 0 : ref.offsetLeft) !== null) setShowSticky(stickyRef.current.getBoundingClientRect().top < 60);
            };
            window.addEventListener("scroll", handleScroll);
            return function() {
                window.removeEventListener("scroll", handleScroll);
            };
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(schemas_RichContent, {
                product: product,
                catalogPrice: catalogPrice
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(products_YDSProductPageBreadcrumb, {
                productBreadcrumb: productBreadcrumb
            }),
            modalContent && modalContent.isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(FullModal, {
                title: modalContent.title,
                isOpen: modalContent.isOpen,
                overlayClassName: "bg-ui-white sm:bg-overlay-primary-100",
                headerBackgroundColor: "bg-brand-primary-300 sm:bg-transparent",
                onClose: function() {
                    return setModalContent(INITIAL_MODAL_CONTENT);
                },
                children: modalContent.content
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mb-4 flex flex-col lg:flex-row lg:gap-x-6",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-full lg:w-1/2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImageSlider_ProductImageSlider, {
                                            productName: product.name,
                                            images: product.images
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "w-full lg:w-1/2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "mt-4 flex flex-row items-center justify-between lg:mt-0",
                                                children: [
                                                    product.brand && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_Link["default"], {
                                                        className: "mt-1 font-body text-ui-gray-500 hover:text-ui-gray-700",
                                                        href: "/b/".concat(product.brand),
                                                        underline: true,
                                                        children: product.brand
                                                    }),
                                                    !product.isBundle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "ml-8 flex items-center",
                                                        style: {
                                                            cursor: "pointer"
                                                        },
                                                        onClick: function() {
                                                            modules/* scroller.scrollTo */.OK.scrollTo("resena", {
                                                                isDynamic: true,
                                                                duration: 600,
                                                                delay: 100,
                                                                smooth: true,
                                                                offset: -120
                                                            });
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* default */.Z, {
                                                            size: isMobileXS ? "sm" : "md",
                                                            review: (0,src/* get_ */.jR)(product, [
                                                                "reviews",
                                                                "count"
                                                            ]),
                                                            rating: (0,src/* get_ */.jR)(product, [
                                                                "reviews",
                                                                "average"
                                                            ], 0)
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Blobs_Blobs, {
                                                blobs: product.blobs,
                                                name: product.name
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPriceForQuantity/* default */.Z, {
                                                pricesWrapperClassName: "flex-col",
                                                discountsWrapperClassName: "mb-0.5",
                                                context: "product-page",
                                                product: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, product), {
                                                    catalogPrice: catalogPrice
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hr/* default */.Z, {}),
                                            productDescriptionPlainText.length > 150 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    productDescriptionPlainText.substring(0, 150),
                                                    "...",
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_Link["default"], {
                                                        onClick: function() {
                                                            setModalContent({
                                                                title: "Acerca de",
                                                                isOpen: true,
                                                                content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    dangerouslySetInnerHTML: {
                                                                        __html: product.description
                                                                    }
                                                                })
                                                            });
                                                        },
                                                        className: "cursor-pointer underline",
                                                        children: "Leer m\xe1s"
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                dangerouslySetInnerHTML: {
                                                    __html: product.description
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hr/* default */.Z, {
                                                className: "mt-2 mb-4"
                                            }),
                                            product.certifications && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "m-0 flex w-full flex-row flex-wrap",
                                                children: product.certifications.map(function(certificate, index) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(UspImageText/* default */.Z, {
                                                        image: certificate,
                                                        text: certificate.name,
                                                        className: "mb-5 inline-block w-1/4 last:mr-0 sm:mr-4 sm:w-20",
                                                        textSize: "text-[.65rem] sm:text-caption"
                                                    }, "certificate-" + index);
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mb-6",
                                                ref: stickyRef,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCart, {
                                                    context: "productPage",
                                                    product: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, product), {
                                                        availability: availability,
                                                        firstApplicableRule: firstApplicableRule
                                                    })
                                                })
                                            }),
                                            uspPromo && /*#__PURE__*/ (0,jsx_runtime.jsx)(Usp/* default */.Z, {
                                                image: uspPromo.icon,
                                                content: uspPromo.text,
                                                altText: "Env\xedo",
                                                context: "promo"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            Boolean(product.isBundle && bundleProducts.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: "C\xf3mpralos por separado"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(YDSProductSlider, {
                                        products: bundleProducts
                                    }, "Slider0")
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetails, {
                        isMobile: isMobile,
                        product: product,
                        modalContent: modalContent,
                        setModalContent: setModalContent,
                        PATH_PRODUCT_PAGE: paths/* PATH_PRODUCT_PAGE */.dK
                    }),
                    !product.isBundle && /*#__PURE__*/ (0,jsx_runtime.jsx)(YDSRelatedProductsSlider, {
                        product: product
                    }),
                    !product.isBundle && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductReviews, {
                        product: product,
                        uspPromise: uspPromise
                    })
                ]
            }),
            isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCartSticky, {
                show: showSticky,
                context: "productPage",
                catalog: catalog,
                product: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, product), {
                    availability: availability,
                    catalogPrice: catalogPrice,
                    firstApplicableRule: firstApplicableRule
                })
            })
        ]
    });
};
ProductPage.defaultProps = {};
ProductPage.propTypes = {
    uspPromo: prop_types.object,
    uspPromise: prop_types.object,
    product: prop_types.object.isRequired,
    productBreadcrumb: prop_types.array
};
/* harmony default export */ var products_ProductPage = (ProductPage);


/***/ }),

/***/ 51586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Page_layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2952);
/* harmony import */ var _yema_designkit_webkit_molecules_NotFound__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32012);







var NotFoundLayout = function(param) {
    var staticContent = param.staticContent;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "robots",
                    content: "noindex"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Page_layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                staticContent: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, staticContent), {
                    metaTags: {
                        title: "P\xe1gina no encontrada",
                        shouldIndex: false,
                        dismissSeoTags: true
                    }
                }),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_yema_designkit_webkit_molecules_NotFound__WEBPACK_IMPORTED_MODULE_4__["default"], {})
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (NotFoundLayout);


/***/ }),

/***/ 22514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ initializeUserContext; }
/* harmony export */ });
/* harmony import */ var sf_modules__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37555);
/* harmony import */ var base_64__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21166);
/* harmony import */ var base_64__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(base_64__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _yema_commerce_store_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86086);



var rebuildStoreFromCookies = function(dispatch) {
    var ctx = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var req = ctx ? ctx.req : null;
    var authInfos = sf_modules__WEBPACK_IMPORTED_MODULE_0__/* .cookie.get */ .pR.get("y_usr", req);
    var checkoutInfos = sf_modules__WEBPACK_IMPORTED_MODULE_0__/* .cookie.get */ .pR.get("y_chkt_id", req);
    var actionsToDispatch = [];
    // RE AUTHENTICATE
    if (authInfos) {
        authInfos = JSON.parse(decodeURIComponent(base_64__WEBPACK_IMPORTED_MODULE_1___default().decode(authInfos)));
        actionsToDispatch.push({
            type: _yema_commerce_store_types__WEBPACK_IMPORTED_MODULE_2__/* .AUTHENTICATE */ .eK,
            payload: authInfos
        });
    } else {
        actionsToDispatch.push({
            type: _yema_commerce_store_types__WEBPACK_IMPORTED_MODULE_2__/* .SET_GUEST_CUSTOMER */ .Hw
        });
    }
    // REBUILD THE CART
    actionsToDispatch.push({
        type: _yema_commerce_store_types__WEBPACK_IMPORTED_MODULE_2__/* .CHECKOUT_RESTORE */ .fA,
        payload: {
            checkoutID: checkoutInfos
        }
    });
    dispatch(actionsToDispatch);
};
function initializeUserContext(param) {
    var authToken = param.authToken, dispatch = param.dispatch, _context = param.context, context = _context === void 0 ? null : _context;
    var isServer = "object" === "undefined";
    if (isServer || !authToken) rebuildStoreFromCookies(dispatch, isServer ? context : null);
    dispatch({
        type: _yema_commerce_store_types__WEBPACK_IMPORTED_MODULE_2__/* .SET_STORE_AS_INITIALIZED */ .dB
    });
};


/***/ }),

/***/ 81666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ArrowDown_ArrowDown; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../../packages/icons/solid/esm/ChevronDownIcon.js
var ChevronDownIcon = __webpack_require__(13398);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/assets/animations/ArrowDown/ArrowDown.jsx




var ArrowDown = function(param) {
    var open = param.open, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDownIcon/* default */.Z, {
        className: classnames_default()(className, "shrink-0 transition duration-300 ease-in-out", {
            "h-5 w-5": !className,
            "rotate-x-180": open
        })
    });
};
ArrowDown.defaultProps = {};
ArrowDown.propTypes = {
    open: prop_types_default().oneOfType([
        (prop_types_default()).bool,
        (prop_types_default()).string
    ])
};
/* harmony default export */ var ArrowDown_ArrowDown = (ArrowDown);

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/assets/animations/ArrowDown/index.js



/***/ }),

/***/ 68113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Badge_Badge; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/Link/index.js
var Link = __webpack_require__(35384);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/atoms/Badge/Badge.jsx








var Badge = function(param) {
    var className = param.className, bgColor = param.bgColor, textColor = param.textColor, type = param.type, children = param.children, href = param.href, style = param.style;
    var _obj;
    var rootClass = classnames_default()(className, "inline-block font-body", (_obj = {
        "shadow-down text-small rounded-l-none rounded-r-sm px-2 py-1": type === "generic" || type === "initial" || type === "stockout",
        "text-small rounded-xxl px-2 py-1": type === "round",
        "shadow-down text-caption leading-tight border-solid border border-brand-primary-700 rounded-sm px-1 py-0": type === "discount",
        "shadow-down font-body font-body-normal text-small underline rounded-bl-md px-2 py-1 cursor-pointer": type === "linkTop",
        "shadow-down font-body font-body-normal text-small underline rounded-tl-md px-2 py-1 cursor-pointer": type === "linkBottom",
        "bg-brand-secondary-700": !bgColor && type === "generic",
        "bg-ui-success": !bgColor && type === "round",
        "bg-brand-tertiary-500": !bgColor && type === "initial",
        "bg-ui-gray-300": !bgColor && type === "stockout",
        "bg-ui-white": !bgColor && type === "discount"
    }, (0,_define_property/* default */.Z)(_obj, bgColor, bgColor), (0,_define_property/* default */.Z)(_obj, "text-ui-white", !textColor && (type === "generic" || type === "initial" || type === "round")), (0,_define_property/* default */.Z)(_obj, "text-ui-gray-900", !textColor && type === "stockout"), (0,_define_property/* default */.Z)(_obj, "text-brand-primary-700", !textColor && type === "discount"), (0,_define_property/* default */.Z)(_obj, "text-ui-black", !textColor && (type === "linkTop" || type === "linkBottom")), (0,_define_property/* default */.Z)(_obj, "font-body-normal ".concat(textColor), textColor), _obj));
    var colorRGB = "#FDF2F1";
    var colorRGBA = colorRGB + "80";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: rootClass,
        style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, style), {
            backgroundColor: type === "linkBottom" || type === "linkTop" ? colorRGBA : ""
        }),
        children: type === "linkBottom" || type === "linkTop" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link["default"], {
            href: href,
            children: children
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: children
        })
    });
};
Badge.defaultProps = {
    type: "generic"
};
Badge.propTypes = {
    className: prop_types.string,
    textColor: prop_types.string,
    bgColor: prop_types.string,
    /** Badge variants: intial, stock-out, generic, discount, etc. */ type: prop_types.oneOf([
        "generic",
        "round",
        "initial",
        "stockout",
        "discount",
        "linkTop",
        "linkBottom", 
    ]),
    children: prop_types.string.isRequired,
    href: prop_types.string
};
/* harmony default export */ var Badge_Badge = (Badge);

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/atoms/Badge/index.js



/***/ }),

/***/ 62581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Breadcrumb_Breadcrumb; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/Link/index.js
var Link = __webpack_require__(35384);
;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/atoms/Breadcrumb/Breadcrumb.jsx





var BreadcrumItem = function(param) {
    var lastBreadcrumbItem = param.lastBreadcrumbItem, link = param.link, title = param.title, hoverable = param.hoverable;
    var linkClassName = "leading-5 font-body font-thin text-small relative transition duration-300 ease-out group";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
        children: [
            !hoverable || lastBreadcrumbItem ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: classnames_default()(linkClassName, "mb-0 inline-block cursor-default"),
                children: title
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link["default"], {
                href: link,
                "data-info": title,
                underline: false,
                className: linkClassName,
                children: [
                    title,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "absolute bottom-0 left-0 hidden h-px w-full origin-left transform bg-ui-black transition duration-300 ease-out group-hover:scale-100 md:scale-0 lg:block"
                    })
                ]
            }),
            lastBreadcrumbItem ? "" : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "inline-block px-2 font-body text-small font-thin leading-5",
                children: "/"
            })
        ]
    });
};
var Breadcrumb = function(param) {
    var breadcrumbs = param.breadcrumbs, className = param.className, style = param.style;
    var wrapperClassName = classnames_default()(className, "flex flex-wrap items-end");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: wrapperClassName,
        style: style,
        children: breadcrumbs.map(function(b, index, param) {
            var length = param.length;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadcrumItem, {
                    title: b.title,
                    lastBreadcrumbItem: length - 1 == index,
                    hoverable: !!b.link,
                    index: index,
                    link: b.link
                })
            }, index);
        })
    });
};
Breadcrumb.defaultProps = {};
Breadcrumb.propTypes = {
    breadcrumbs: prop_types.array.isRequired,
    className: prop_types.string,
    style: prop_types.object
};
/* harmony default export */ var Breadcrumb_Breadcrumb = (Breadcrumb);

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/atoms/Breadcrumb/index.js



/***/ }),

/***/ 75017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ BulletIndicator_BulletIndicator; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/atoms/BulletIndicator/BulletIndicator.jsx





var BulletIndicator = function(param) {
    var className = param.className, bulletSize = param.bulletSize, type = param.type, onClick = param.onClick;
    var _obj;
    var bulletClassName = classnames_default()(className, "transition duration-300 ease-out", (_obj = {
        "rounded-full mx-1": type === "dot",
        "w-3 h-3": type === "dot" && !bulletSize
    }, (0,_define_property/* default */.Z)(_obj, bulletSize, bulletSize), (0,_define_property/* default */.Z)(_obj, "w-full h-[5px]", type === "rect"), _obj));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        className: bulletClassName,
        onClick: onClick
    });
};
BulletIndicator.defaultProps = {
    type: "dot"
};
BulletIndicator.propTypes = {
    className: prop_types.string,
    bulletSize: prop_types.string,
    type: prop_types.oneOf([
        "dot",
        "rect"
    ]),
    onClick: prop_types.func
};
/* harmony default export */ var BulletIndicator_BulletIndicator = (BulletIndicator);

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/atoms/BulletIndicator/index.js



/***/ }),

/***/ 40636:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Hr_Hr; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/Hr/Hr.module.scss
var Hr_module = __webpack_require__(91057);
var Hr_module_default = /*#__PURE__*/__webpack_require__.n(Hr_module);
;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/atoms/Hr/Hr.jsx








var Hr = function(_param) {
    var text = _param.text, className = _param.className, color = _param.color, style = _param.style, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "text",
        "className",
        "color",
        "style"
    ]);
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", (0,_object_spread/* default */.Z)({
        className: classnames_default()("my-4", className, (_obj = {}, (0,_define_property/* default */.Z)(_obj, (Hr_module_default()).hrWithText, text), (0,_define_property/* default */.Z)(_obj, color, color), (0,_define_property/* default */.Z)(_obj, "border-ui-gray-300", !color), _obj)),
        style: style,
        "data-content": text
    }, otherProps));
};
Hr.defaultProps = {
    text: null,
    color: null
};
Hr.propTypes = {
    text: prop_types.string,
    className: prop_types.string,
    color: prop_types.string,
    style: prop_types.object
};
/* harmony default export */ var Hr_Hr = (Hr);

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/atoms/Hr/index.js



/***/ }),

/***/ 29832:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ProductPriceForQuantity; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var sf_modules__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37555);
/* harmony import */ var _Badge__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68113);





ProductPriceForQuantity.propTypes = {
    wrapperClassName: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    pricesWrapperClassName: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    discountsWrapperClassName: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    context: prop_types__WEBPACK_IMPORTED_MODULE_4__.oneOf([
        "pos",
        "cart",
        "checkout",
        "success",
        "profileOrder",
        "hit",
        "product-page",
        "modal",
        "default", 
    ]),
    product: prop_types__WEBPACK_IMPORTED_MODULE_4__.object,
    hideDiscounts: prop_types__WEBPACK_IMPORTED_MODULE_4__.bool
};
ProductPriceForQuantity.defaultProps = {
    context: "default",
    hideDiscounts: false
};
function ProductPriceForQuantity(param) {
    var wrapperClassName = param.wrapperClassName, pricesWrapperClassName = param.pricesWrapperClassName, discountsWrapperClassName = param.discountsWrapperClassName, hideDiscounts = param.hideDiscounts, context = param.context, product = param.product;
    if (!(product === null || product === void 0 ? void 0 : product.catalogPrice)) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    if (product.isGift) {
        var nbGifts = product.productsGifted || 1;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
            className: "font-semibold font-body text-normal leading-tight text-ui-gray-900",
            children: [
                "Regalo",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    className: "ml-1 text-small font-body-regular text-ui-gray-500",
                    children: [
                        "(",
                        nbGifts,
                        " unidad",
                        nbGifts > 1 && "es",
                        ")"
                    ]
                })
            ]
        });
    }
    var regularPricePerUnit;
    var priceToPayPerUnit;
    var totalPriceToPay;
    var pricePerQuantityUnit;
    var sellingValue = Number(product.sellingValue);
    var refinedSellingValue = Number.isInteger(sellingValue) ? sellingValue : sellingValue.toFixed(1);
    var productQuantityForPrice = product.sellingUnit && "(".concat(refinedSellingValue, " ").concat(product.sellingUnit, ")");
    var isBuyingContext = false;
    switch(context){
        case "pos":
        case "cart":
        case "checkout":
            isBuyingContext = true;
            totalPriceToPay = product.totalPrice;
            priceToPayPerUnit = totalPriceToPay / product.billedQuantity;
            regularPricePerUnit = priceToPayPerUnit < product.catalogPrice.price ? product.catalogPrice.price : null;
            break;
        case "success":
        case "profileOrder":
            isBuyingContext = true;
            totalPriceToPay = product.paidPricing.totalPrice;
            priceToPayPerUnit = totalPriceToPay / product.billedQuantity;
            regularPricePerUnit = priceToPayPerUnit < product.paidPricing.priceUndiscounted ? product.paidPricing.priceUndiscounted : null;
            break;
        case "product-page":
            totalPriceToPay = null;
            priceToPayPerUnit = product.catalogPrice.discountedPrice;
            regularPricePerUnit = priceToPayPerUnit < product.catalogPrice.price ? product.catalogPrice.price : null;
            pricePerQuantityUnit = refinedSellingValue && "".concat(sf_modules__WEBPACK_IMPORTED_MODULE_2__/* .money.formatMoney */ .CZ.formatMoney(product.catalogPrice.discountedPrice / refinedSellingValue), " / ").concat(product.sellingUnit);
            break;
        default:
            totalPriceToPay = null;
            priceToPayPerUnit = product.catalogPrice.discountedPrice;
            regularPricePerUnit = priceToPayPerUnit < product.catalogPrice.price ? product.catalogPrice.price : null;
            productQuantityForPrice = product.sellingUnit && refinedSellingValue + " " + product.sellingUnit;
            break;
    }
    var saleByWeight = product.sellingType && product.sellingType !== "por-pieza";
    var showProductQuantityForPrice = !saleByWeight || context === "default";
    var discount = sf_modules__WEBPACK_IMPORTED_MODULE_2__/* .money.getDiscount */ .CZ.getDiscount(priceToPayPerUnit, regularPricePerUnit);
    var sellingPresentation = saleByWeight && refinedSellingValue ? " / ".concat(refinedSellingValue > 1 ? "".concat(refinedSellingValue, " ") : "").concat(product.sellingUnit) : product.isBundle ? " / pack" : " / pz";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(wrapperClassName, {
            "mt-1 flex w-full flex-col-reverse md:flex-row md:items-end md:justify-between": showProductQuantityForPrice
        }),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(pricesWrapperClassName, "mr-2 flex justify-start"),
                children: [
                    !hideDiscounts && regularPricePerUnit && discount ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(discountsWrapperClassName, "flex items-center"),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("mr-1", "font-body leading-tight line-through", "text-caption text-ui-gray-500"),
                                children: sf_modules__WEBPACK_IMPORTED_MODULE_2__/* .money.formatMoney */ .CZ.formatMoney(regularPricePerUnit)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Badge__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                type: "discount",
                                children: discount
                            })
                        ]
                    }) : context !== "pos" && !hideDiscounts ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "h-4"
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-wrap items-center font-body text-normal",
                        children: [
                            !hideDiscounts && isBuyingContext && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "flex-shrink-0 text-sm font-body-bold text-ui-gray-900",
                                        children: sf_modules__WEBPACK_IMPORTED_MODULE_2__/* .money.formatMoney */ .CZ.formatMoney(totalPriceToPay)
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "mx-2 inline-block h-1 w-1 flex-shrink-0 rounded-full bg-brand-secondary-700"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("flex-shrink-0", isBuyingContext ? "leading-tight text-ui-gray-500" : "font-body-bold text-ui-gray-900", context === "hit" ? "text-caption" : "text-normal"),
                                children: [
                                    sf_modules__WEBPACK_IMPORTED_MODULE_2__/* .money.formatMoney */ .CZ.formatMoney(priceToPayPerUnit),
                                    context !== "default" && sellingPresentation
                                ]
                            })
                        ]
                    })
                ]
            }),
            showProductQuantityForPrice && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("flex-shrink-0 font-body leading-tight md:flex md:items-end", "text-left text-ui-gray-900 md:text-right", context === "product-page" ? "text-normal font-body-regular lg:flex-col" : "text-small font-body-regular"),
                children: [
                    pricePerQuantityUnit && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "hidden text-caption font-body-regular text-ui-gray-500 lg:block",
                        children: pricePerQuantityUnit
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "text-caption text-black",
                        children: productQuantityForPrice
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 50952:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Rating_Rating; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../packages/sf-modules/src/index.js + 26 modules
var src = __webpack_require__(37555);
// EXTERNAL MODULE: ../../packages/icons/solid/esm/StarIcon.js
var StarIcon = __webpack_require__(57764);
;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/atoms/Rating/Stars.js






function between(x, min, max) {
    return x >= min && x <= max;
}
function setRating(rating) {
    var decimals = rating - Math.floor(rating);
    var newRating = +decimals.toFixed(1);
    var integer = src/* polyfills.truncate */.dF.truncate(rating);
    if (between(newRating, 0.1, 0.3)) rating = integer + 0.4;
    else if (between(newRating, 0.31, 0.5)) rating = integer + 0.5;
    return rating / 0.05;
}
// Hover and click allowed.
var StarsHovered = function(param) {
    var sizes = param.sizes, rating = param.rating, hovered = param.hovered, onChange = param.onChange;
    var handleChange = function handleChange(value) {
        if (hovered) {
            setClickScore(value);
            onChange(value);
        }
    };
    var handleHover = function handleHover(value) {
        if (hovered) {
            setHoverScore(value);
        }
    };
    var ref = (0,react.useState)(rating), clickScore = ref[0], setClickScore = ref[1];
    var ref1 = (0,react.useState)(rating), hoverScore = ref1[0], setHoverScore = ref1[1];
    return [
        1,
        2,
        3,
        4,
        5
    ].map(function(ratingValue) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "px-1",
            onClick: function() {
                return handleChange(ratingValue);
            },
            onMouseOver: function() {
                return handleHover(ratingValue);
            },
            onMouseOut: function() {
                return handleHover(0);
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StarIcon/* default */.Z, {
                className: classnames_default()(sizes.iconSize, ratingValue <= (hoverScore || clickScore) ? "text-ui-warning" : "text-ui-gray-300")
            })
        }, ratingValue);
    });
};
var Stars = function(param) {
    var size = param.size, rating = param.rating, hovered = param.hovered, onChange = param.onChange;
    var sizes = {
        iconSize: size === "lg" ? "w-10 h-10" : size === "md" ? "w-6 h-6" : "w-4 h-4",
        totalWidth: size === "lg" ? "w-[15rem]" : size === "md" ? "w-[10rem]" : "w-[7.5rem]"
    };
    var ratingWidth = setRating(rating);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative -ml-1",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex leading-none",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StarsHovered, {
                    sizes: sizes,
                    rating: rating,
                    hovered: hovered,
                    onChange: onChange
                })
            }),
            !hovered && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute top-0 left-0 h-full overflow-hidden",
                style: {
                    width: ratingWidth + "%"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()(sizes.totalWidth, "text-left leading-none"),
                    children: [
                        1,
                        2,
                        3,
                        4,
                        5
                    ].map(function(ratingValue) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "px-1",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StarIcon/* default */.Z, {
                                className: classnames_default()(sizes.iconSize, "text-ui-warning")
                            })
                        }, ratingValue);
                    })
                })
            })
        ]
    });
};
Stars.propTypes = {
    size: prop_types.oneOf([
        "sm",
        "md",
        "lg"
    ]),
    rating: prop_types.number,
    hovered: prop_types.bool,
    onChange: prop_types.func
};
Stars.defaultProps = {
    hovered: false,
    size: "sm"
};
/* harmony default export */ var Rating_Stars = (/*#__PURE__*/react.memo(Stars));

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/atoms/Rating/Rating.jsx





var Rating = function(param) {
    var className = param.className, size = param.size, review = param.review, rating = param.rating, hovered = param.hovered, onChange = param.onChange;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()("flex w-auto flex-wrap items-center", className),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating_Stars, {
                    onChange: onChange,
                    hovered: hovered,
                    size: size,
                    rating: rating
                }),
                review != null && !hovered && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "font-regular ml-1 font-body text-caption font-body-regular text-ui-gray-900",
                    style: {
                        marginTop: "2px"
                    },
                    children: [
                        "(",
                        review,
                        ")"
                    ]
                })
            ]
        })
    });
};
Rating.propTypes = {
    className: prop_types.string,
    size: prop_types.oneOf([
        "sm",
        "md",
        "lg"
    ]),
    review: prop_types.number,
    rating: prop_types.number,
    hovered: prop_types.bool
};
Rating.defaultProps = {
    size: "sm"
};
/* harmony default export */ var Rating_Rating = (Rating);

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/atoms/Rating/index.js



/***/ }),

/***/ 98504:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ UspImageText_UspImageText; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/Image/index.js
var Image = __webpack_require__(4740);
;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/atoms/UspImageText/UspImageText.jsx






var UspImageText = function(param) {
    var text = param.text, textMobile = param.textMobile, textSize = param.textSize, textColor = param.textColor, className = param.className, icon = param.icon, image = param.image;
    var baseClass = "flex flex-col items-center text-center";
    var rootClass = classnames_default()(baseClass, className);
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: rootClass,
        children: [
            icon,
            image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-[30px] sm:w-[48px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    layout: "fixed",
                    width: 48,
                    height: 48,
                    src: image.logoUrl,
                    alt: image.value
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: classnames_default()("mb-0 mt-2.5 font-body", (_obj = {}, (0,_define_property/* default */.Z)(_obj, textColor, textColor), (0,_define_property/* default */.Z)(_obj, textSize, textSize), (0,_define_property/* default */.Z)(_obj, "text-caption xl:text-small", !textSize), _obj)),
                children: [
                    text && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: classnames_default()({
                            "hidden xl:block": textMobile,
                            block: !textMobile
                        }),
                        children: text
                    }),
                    textMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "block xl:hidden",
                        children: textMobile
                    })
                ]
            })
        ]
    });
};
UspImageText.displayName = "UspImageText";
UspImageText.defaultProps = {};
UspImageText.propTypes = {
    text: prop_types.string,
    textMobile: prop_types.string,
    textColor: prop_types.string,
    textSize: prop_types.string,
    icon: prop_types.object,
    image: prop_types.shape({
        logoUrl: prop_types.string,
        value: prop_types.string
    }),
    className: prop_types.string
};
/* harmony default export */ var UspImageText_UspImageText = (UspImageText);

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/atoms/UspImageText/index.js



/***/ }),

/***/ 79674:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68810);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _assets_animations_ArrowDown__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81666);





var Accordion = function(param) {
    var title = param.title, toggleAccordion = param.toggleAccordion, active = param.active, children = param.children, filled = param.filled, withBorder = param.withBorder, childrenClassName = param.childrenClassName;
    var accordionToggle = classnames__WEBPACK_IMPORTED_MODULE_1___default()("w-full flex flex-row justify-between items-center font-body p-2 cursor-pointer transition duration-300 ease-in", active || !withBorder ? "border-b-0" : "border-b border-ui-gray-900");
    var accordionActive = withBorder ? "border-b border-ui-gray-900" : "";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("h-max w-full", active && accordionActive),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(accordionToggle, filled && "bg-black text-white"),
                onClick: function() {
                    return toggleAccordion();
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        itemProp: "name",
                        className: "mb-0 text-h3",
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_animations_ArrowDown__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            open: active,
                            className: filled ? "h-5 w-5 text-ui-white" : null
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_3__/* .Transition */ .u, {
                show: active,
                enter: "transition ease-out duration-200",
                enterFrom: "transform opacity-0 scale-95",
                enterTo: "transform opacity-100 scale-100",
                leave: "transition ease-in duration-150",
                leaveFrom: "transform opacity-100 scale-100",
                leaveTo: "transform opacity-0 scale-95",
                children: active && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("p-2", childrenClassName, filled ? "bg-brand-primary-100" : ""),
                    children: children
                })
            })
        ]
    });
};
Accordion.defaultProps = {
    filled: false
};
Accordion.propTypes = {
    title: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string.isRequired),
    toggleAccordion: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func.isRequired),
    active: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool.isRequired),
    children: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().node),
    filled: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
    withBorder: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
    childrenClassName: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (Accordion);


/***/ }),

/***/ 55049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Usp_Usp; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../packages/icons/solid/esm/TruckIcon.js
var TruckIcon = __webpack_require__(66992);
// EXTERNAL MODULE: ../../packages/icons/solid/esm/PromiseIcon.js
var PromiseIcon = __webpack_require__(66569);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/Image/index.js
var Image = __webpack_require__(4740);
;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/molecules/Usp/Usp.jsx





var Usp = function(param) {
    var className = param.className, image = param.image, altText = param.altText, title = param.title, content = param.content, context = param.context;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "\n        flex rounded-sm border \n        border-ui-gray-300 bg-ui-white p-5\n        ".concat(title ? "flex-col items-start justify-start" : "flex-row items-center justify-center", "\n        ").concat(className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-2 mr-2 flex items-center gap-2",
                children: [
                    image && typeof image === "string" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        layout: "fixed",
                        src: image,
                        alt: altText,
                        width: title ? 24 : 43,
                        height: title ? 24 : 43
                    }) : context === "promo" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TruckIcon/* default */.Z, {
                        className: title ? "h-6 w-6" : "h-10 w-10"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PromiseIcon/* default */.Z, {
                        className: title ? "h-6 w-6" : "h-10 w-10"
                    }),
                    title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        className: "font-semibold mb-0 font-body text-normal leading-tight",
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: content
                },
                className: "font-light font-body text-small [&_p]:mb-0"
            })
        ]
    });
};
Usp.displayName = "Usp";
Usp.defaultProps = {};
Usp.propTypes = {
    className: prop_types.string,
    image: prop_types.string,
    altText: prop_types.string,
    title: prop_types.string,
    content: prop_types.string,
    context: prop_types.string
};
/* harmony default export */ var Usp_Usp = (Usp);

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/molecules/Usp/index.js



/***/ }),

/***/ 91057:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hrWithText":"Hr_hrWithText__t6057"};

/***/ }),

/***/ 77912:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"KeenSliderWrapper":"ProductImageSlider_KeenSliderWrapper__m2ug0","IizWrapper":"ProductImageSlider_IizWrapper__1FTzy"};

/***/ }),

/***/ 32841:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

function CameraIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M42.512 15.5c-.992 0-1.86.492-2.41 1.152-.551.66-.867 1.457-1.07 2.27l-1.825 7.281H19.848c-7.441 0-13.52 5.723-13.52 12.859V71.64c0 7.137 6.078 12.859 13.52 12.859H80.16c7.442 0 13.512-5.723 13.512-12.859V39.062c0-6.863-5.656-12.43-12.703-12.848v-1.785a3.695 3.695 0 00-3.676-3.676h-7.386c-2.016 0-3.668 1.66-3.668 3.676v1.773H62.8l-1.828-7.285c-.203-.809-.515-1.605-1.07-2.266-.55-.66-1.418-1.152-2.41-1.152zm0 2.023h14.98c.39 0 .594.121.855.434.262.312.504.84.66 1.46l2.02 8.044c.113.453.516.77.98.77h5.27a1.015 1.015 0 00.996-1.184c-.012-.086-.008-.102-.008-.082V24.43c0-.93.707-1.645 1.637-1.645h7.39c.93 0 1.645.715 1.645 1.645v2.535c0-.07-.004-.028-.023.168a1.01 1.01 0 001.011 1.097h.23c6.411 0 11.485 4.844 11.485 10.832V71.64c0 5.989-5.074 10.832-11.484 10.832h-60.31c-6.41 0-11.491-4.843-11.491-10.832V39.062c0-5.988 5.082-10.832 11.492-10.832h18.152c.465 0 .867-.316.98-.77l2.024-8.046c.156-.617.398-1.148.656-1.46.262-.313.461-.434.855-.434zm3.793 1.422a3.69 3.69 0 00-3.676 3.676l.004 2.527a3.69 3.69 0 003.676 3.676h7.39c2.02 0 3.669-1.656 3.669-3.676v-2.53c0-2.02-1.649-3.677-3.668-3.677zm0 2.028h7.39c.93 0 1.641.718 1.641 1.648v2.527c0 .93-.71 1.649-1.64 1.649h-7.387c-.93 0-1.645-.72-1.645-1.649v-2.53c0-.93.715-1.65 1.645-1.65zM17.266 31.055a3.69 3.69 0 00-3.676 3.675v2.528a3.69 3.69 0 003.676 3.675h7.387a3.69 3.69 0 003.676-3.675V34.73a3.69 3.69 0 00-3.676-3.675zm0 2.027h7.387c.93 0 1.648.719 1.648 1.648v2.528c0 .93-.719 1.648-1.648 1.648h-7.387c-.93 0-1.648-.719-1.648-1.648V34.73c0-.93.718-1.648 1.648-1.648zM50 37.094c-11.574 0-20.98 9.406-20.98 20.98S38.426 79.047 50 79.047s20.98-9.399 20.98-20.973-9.406-20.98-20.98-20.98zm0 2.027c10.48 0 18.953 8.476 18.953 18.953 0 10.48-8.477 18.945-18.953 18.945-10.48 0-18.953-8.469-18.953-18.945 0-10.48 8.477-18.953 18.953-18.953zm0 4.32c-8.066 0-14.625 6.567-14.625 14.633C35.375 66.141 41.934 72.7 50 72.7s14.625-6.558 14.625-14.625c0-8.066-6.559-14.633-14.625-14.633zm0 2.027c6.969 0 12.598 5.637 12.598 12.605S56.969 70.671 50 70.671s-12.598-5.628-12.598-12.598S43.031 45.468 50 45.468zm.336 2.524c-1.352.012-1.34 2.039.016 2.027a8.064 8.064 0 016.602 12.137c-.684 1.168 1.066 2.195 1.75 1.027a10.094 10.094 0 00-8.27-15.191h-.098z"
  }));
}
const ForwardRef = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(CameraIcon);
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ }),

/***/ 14718:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

function CheckIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M8.25 21a.375.375 0 01-.265-.11L3.11 16.015a.375.375 0 01.53-.53l4.563 4.562L20.32 3.156a.378.378 0 01.523-.086.372.372 0 01.152.244.372.372 0 01-.065.28L8.554 20.844A.376.376 0 018.28 21h-.03z"
  }));
}
const ForwardRef = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(CheckIcon);
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ }),

/***/ 13398:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

function ChevronDownIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M11.999 17a.895.895 0 01-.624-.244l-9.27-9.151a.332.332 0 01.036-.513A.453.453 0 012.416 7c.12 0 .234.045.313.123l9.27 9.15 9.272-9.15A.446.446 0 0121.584 7c.101 0 .2.033.275.091a.333.333 0 01.036.514l-9.271 9.15a.912.912 0 01-.625.244z"
  }));
}
const ForwardRef = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(ChevronDownIcon);
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ }),

/***/ 66569:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

function PromiseIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 22",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M6.19 21.504a.355.355 0 00.497 0L8.07 20.12a.352.352 0 00-.497-.497l-1.135 1.135-5.59-5.589 3.004-3.004a3.448 3.448 0 001.02-2.313c.044-1.171.548-2.4 1.473-3.61a2.066 2.066 0 00.586 1.194L9.025 9.53a2.08 2.08 0 002.751.143l.003-.002c.204-.168.379-.374.505-.606.098-.004.197-.016.293-.035a2.125 2.125 0 00.009.826c.083.39.282.754.567 1.034.384.377.905.591 1.444.591.54 0 1.07-.219 1.452-.6l.003-.002 4.933-4.933a1.367 1.367 0 011.916 0 1.357 1.357 0 010 1.916l-6.388 6.388c-1.569 1.568-3.214 2.427-4.758 2.485a3.448 3.448 0 00-2.314 1.02l-.874.874a.351.351 0 10.497.497l.875-.874c.5-.5 1.154-.79 1.842-.815 2.179-.08 4.046-1.507 5.23-2.69l6.387-6.388a2.06 2.06 0 000-2.91 2.078 2.078 0 00-2.91 0l-1.745 1.744a2.042 2.042 0 00-.597-1.319 2.078 2.078 0 00-1.848-.565 2.044 2.044 0 00-.565-1.848 2.078 2.078 0 00-1.849-.565 2.044 2.044 0 00-.565-1.848 2.078 2.078 0 00-2.91 0s-3.525 3.526-3.55 3.549C5.678 5.78 4.25 7.647 4.17 9.826a2.747 2.747 0 01-.814 1.842L.103 14.92a.352.352 0 000 .498l6.086 6.086zM8.385 4.628c.353-.002.705.142.958.395l2.094 2.094c.517.516.518 1.393.004 1.911l-.004.005c-.518.518-1.4.516-1.916 0L7.428 6.939a1.37 1.37 0 010-1.916 1.37 1.37 0 01.958-.395zM16.69 5.98c.349 0 .697.13.959.392a1.37 1.37 0 010 1.916l-2.094 2.094-.003.002a1.376 1.376 0 01-1.81.092v-.002c-.614-.49-.66-1.452-.103-2.008l2.093-2.094a1.35 1.35 0 01.958-.392zM14.277 3.56a1.356 1.356 0 01.958 2.313l-2.094 2.094c-.17.168-.384.293-.617.353a2.055 2.055 0 00-.207-1.173c-.1-.197-.25-.354-.382-.528l-.639-.64 2.023-2.022c.256-.256.596-.397.958-.397zm-3.371-2.016c.256-.256.596-.397.958-.397s.702.141.958.397.397.596.397.958-.141.702-.397.958l-2.023 2.023-.958-.958-.001-.002a2.056 2.056 0 00-1.316-.597l2.382-2.382z"
  }));
}
const ForwardRef = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(PromiseIcon);
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ }),

/***/ 57764:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

function StarIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    d: "M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.007 5.404.433c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.433 2.082-5.006z",
    clipRule: "evenodd"
  }));
}
const ForwardRef = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(StarIcon);
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ }),

/***/ 66992:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

function TruckIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 432.5 197",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("style", null, "\n      .cls-1,.cls-2{fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:4px}.cls-2{stroke-linecap:round}\n    ")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M144.5 162h-31V2h246v122M324.5 162H215.41M359.5 124V45.19A19.19 19.19 0 01378.69 26h32.62a19.19 19.19 0 0119.19 19.19v97.62A19.19 19.19 0 01411.31 162H395.5",
    className: "cls-1"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M215.41 162a35.46 35.46 0 11.09-2.49q0 1.26-.09 2.49",
    className: "cls-1"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    cx: 360,
    cy: 159.5,
    r: 35.5,
    className: "cls-1"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M98 117.5H2M98 137.5H22M98 157.5H42",
    className: "cls-2"
  }))));
}
const ForwardRef = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(TruckIcon);
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ })

}]);